const PASSED = { ok: true, message: "" };

const isMatch = (array, data, key = "Unknown") => {
  if (!array.includes(data)) {
    return {
      ok: false,
      message: `${key} should be ${array} but get ${data}`,
    };
  }
  return PASSED;
};

const rules = {
  "guest-instance-create": {
    //Rule to create Guest instance
    hashtags: {
      isRequired: false,
      rule: () => PASSED,
    },
    age: {
      isRequired: true,
      rule: (age) => {
        return isMatch(["1-12", "13-24", "25-60", "Over 60"], age, "Age");
      },
    },
    gender: {
      isRequired: true,
      rule: (gender) => {
        return isMatch(["Male", "Female", "Other"], gender, "Gender");
      },
    },
  },
};

const validate = (ruleName, data) => {
  if (rules[ruleName]) {
    const results = Object.entries(rules[ruleName]).map(([key, value]) => {
      if (value.isRequired) {
        if (!data[key] || data[key] === "") {
          return { key, ok: false, message: `${key} is required` };
        }
      } else {
        //Not required
        if (!data[key] || data[key] === "") {
          return { key, ok: true, message: `` };
        }
      }

      return { key, ...value.rule(data[key]) };
    });

    if (results.every((result) => result.ok)) {
      return { ok: true };
    } else {
      return {
        ok: false,
        messages: results.map((result) => result.message),
      };
    }
  } else throw new Error("Rule name does not exist");
};

export default validate;
